export const enTag = 'en'
export const esTag = 'es'
